import script from "./NavigationLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationLinks.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationLinks.vue?vue&type=style&index=0&id=1e95ebae&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e95ebae"]])

export default __exports__